import { useMutation, useQueryClient } from 'react-query'

import { accountsService } from 'src/services/accounts.service'

import { QUERY_KEYS } from 'src/constants'

const useUpdateAccountNfts = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async () => {
      return accountsService.updateAccountNfts()
    },
    {
      onSuccess: (data, vars) => {
        if (!data) return
        queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT])
      },
    },
  )
}

export { useUpdateAccountNfts }
